import React, { Component } from 'react'
import Dashboard from '../../components/Dashboard/dashboard'

class DashboardRoute extends Component {
 
  render() {
    return (
      <section>
        <Dashboard />
      </section>
    );
  }
}

export default DashboardRoute
